import { useEffect, useState } from "react";
import { api } from "../api";

/** Logotipo da empresa (PJ): busca se há imagem cadastrada e devolve o endereço dela. Atualiza ao salvar em Configurações. */
const EVT = "mm:company-changed";
export const notifyCompanyChanged = () => window.dispatchEvent(new Event(EVT));
export interface CompanyInfo { entityName: string; legalName: string | null; hasLogo: boolean; version: number }
export function useCompany(realm: string, entityId: string | undefined) {
  const [info, setInfo] = useState<CompanyInfo | null>(null);
  const [tick, setTick] = useState(0);
  useEffect(() => { const f = () => setTick((t) => t + 1); window.addEventListener(EVT, f); return () => window.removeEventListener(EVT, f); }, []);
  useEffect(() => {
    if (realm === "admin" || !entityId) { setInfo(null); return; }
    let live = true;
    void api<CompanyInfo>("GET", `/api/${realm}/company?entityId=${entityId}`).then((x) => { if (live) setInfo(x); }).catch(() => { if (live) setInfo(null); });
    return () => { live = false; };
  }, [realm, entityId, tick]);
  const logoUrl = info?.hasLogo && entityId ? `/api/${realm}/company/logo?entityId=${entityId}&v=${info.version}` : null;
  return { info, logoUrl };
}
